import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ListBuilder, Modal, ModalBuilder, TileGrid } from "@redriver/cinnamon";
import ContactCard from "assets/icons/contact-card-blue.svg";
import { ContactTile } from "components/contacts";
import { CustomerTypes } from "constants/enums";
import { getCustomerContacts } from "features/Customers/CustomerDetails/CustomerContacts/actions";

/**
 * Shared by enquiries and jobs - the caller supplies the action that saves the
 * chosen contact against its own entity.
 */
const SelectContactModal = ({
  visible,
  entity,
  contact,
  header,
  action,
  closeModal,
}) => {
  // Null until the user picks a tile, so the entity's current contact stays the
  // selection - including after a refresh swaps the contact prop underneath us.
  const [pickedContactId, setPickedContactId] = useState(null);
  const [modalSubmitting, setModalSubmitting] = useState(false);
  const dispatch = useDispatch();

  const selectedContactId = pickedContactId ?? contact?.id;

  const highlight =
    entity.customerType == CustomerTypes.Residential
      ? "faded-green"
      : "faded-blue";

  return (
    <ModalBuilder
      visible={visible}
      onSubmit={() => {
        setModalSubmitting(true);
        dispatch(action(entity.id, { contactId: selectedContactId })).then(
          () => {
            setModalSubmitting(false);
            setPickedContactId(null);
            closeModal(true);
          },
        );
      }}
      onCancel={() => {
        setPickedContactId(null);
        closeModal();
      }}
      renderModal={(modalProps) => (
        <Modal
          {...modalProps}
          submitting={modalSubmitting}
          header={header}
          submitLabel="Save"
          className="select-contact-modal"
          size="small"
          submitDisabled={!selectedContactId}
        >
          <header>Select Existing Contact</header>
          <ListBuilder
            withTiles
            loadAction={getCustomerContacts}
            loadParams={{ customerId: entity.customerId }}
            renderList={(tileProps) => (
              <TileGrid
                {...tileProps}
                dataKey="id"
                size="large"
                render={(item) => (
                  <ContactTile
                    contact={item}
                    highlight={highlight}
                    backgroundUrl={ContactCard}
                    onClick={() => setPickedContactId(item.id)}
                    highlightFull={item.id == selectedContactId}
                  />
                )}
              />
            )}
          />
        </Modal>
      )}
    />
  );
};

export default SelectContactModal;
